<div class="position-relative"  id="{{'item-' + pollResult.id}}">

    <div class="media card topic-card position-relative" id="{{pollResult.id}}" [ngClass]="{'recurring-poll': pollResult.isRecurring}">
      
        <div class="timeline-item-badge">
            {{'poll_results' | translate }}
            @if(pollResult.reviewed.length > 0){
                <review-badge [reviewInfo]="pollResult.reviewed"></review-badge>
            }
        </div>
         
        <div class="card-top">
            <div class="pt-2 pe-2">
                <i class="fa-sharp-duotone fa-solid fa-chart-simple fa-2x ms-2 pt-1 position-relative"></i>
            </div>

                <div class="card-comment p-3" [ngClass]="{'not-recurring-poll': !pollResult.isRecurring}">
                    <p>{{pollResult.label}}</p>
                    
                    <mat-tab-group (selectedTabChange)="onTabChanged($event);">
                        <mat-tab [label]="resultsTabLabel">
                            <ng-template matTabContent>
                                @if(pollResult.results?.values && participationCount > 0){
                                    <agree-disagree-question-result-bar-chart [values]="pollResult.results.values" 
                                                                              [chartId]="pollResult.id"></agree-disagree-question-result-bar-chart>
                                }@else{
                                    <div class="alert alert-warning mt-2 mb-0 fs-6 fst-italic">
                                        {{'poll_results.no_data'| translate}}
                                    </div>
                                }
                            </ng-template>
                        </mat-tab>
    
                        <mat-tab [label]="trendsTabLabel" [disabled]='!pollResult.isRecurring'>
                            <ng-template matTabContent>
                                @if(tabIndexToShow === 1){
                                    <recurring-poll-result-trends [poll]="pollResult"></recurring-poll-result-trends>
                                }
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>

                
            
            <div class="card-options"></div>
        </div>
        <div class="card-result-comments">
            <poll-result-comments [commentResults]="pollResult.results.values"
                                  [itemType]="pollResult.itemType"></poll-result-comments>
        </div>

        <div class="media-bottom card-bottom">
            <tm-reactions [timelineItem]="pollResult"
                          (onReacted)="onReacted($event)"
                          (onToggleThreads)="toggleThreads()"
                          (onDiscuss)="discuss()"></tm-reactions>

            @if(showThreads){
                <tm-threads [timelineItem]="pollResult" #threadsComponent
                            [userInfos]="userInfos"
                            (onThreadsUpdated)="onThreadsUpdated($event)"></tm-threads>
            }
        </div>
        
    </div>
    @if(pollResult.managerPanel){
        <div class="manager-panel-wrapper"
             [class]="isOdd ? 'odd-timeline-item': 'even-timeline-item'">
            <tm-manager-panel [managerPanel]="pollResult.managerPanel"
                              [reviewed]="pollResult.reviewed.length !== 0"></tm-manager-panel>
        </div>
    }
</div>